module.exports = __webpack_public_path__ + "img/ButtonFour.5f201628.svg";